"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObservableHistory = exports.createObservableHistory = void 0;
const mobx_1 = require("mobx");
const history_1 = require("history");
const observable_search_params_1 = require("./observable-search-params");
function createObservableHistory(history, opts) {
    return new ObservableHistory(history, opts);
}
exports.createObservableHistory = createObservableHistory;
class ObservableHistory {
    constructor(history = history_1.createBrowserHistory(), opts = {}) {
        Object.defineProperty(this, "opts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: opts
        });
        Object.defineProperty(this, "history", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "unbindEvents", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "action", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "location", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "searchParams", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        mobx_1.makeObservable(this);
        this.history = history;
        this.action = this.history.action;
        this.location = this.history.location;
        this.searchParams = new observable_search_params_1.ObservableSearchParams(this.location.search, opts.searchParams);
        this.unbindEvents = this.bindEvents();
        return new Proxy(this, {
            get: (target, prop, context) => {
                let fieldRef = Reflect.get(target, prop, context);
                if (!(prop in target)) {
                    return Reflect.get(this.history, prop, context); // handle history.js native apis
                }
                return fieldRef;
            },
        });
    }
    bindEvents() {
        const disposers = [
            // normalize direct updates of `history.location = string | LocationDescriptor`
            mobx_1.intercept(this, change => {
                if (change.type === "update") {
                    switch (change.name) {
                        case "location":
                            change.newValue = this.normalize(change.newValue);
                            break;
                    }
                }
                return change;
            }),
            // normalize partial updates of `history.location.(search|hash|pathname) = string`
            mobx_1.intercept(this.location, change => {
                if (change.type === "update") {
                    switch (change.name) {
                        case "search":
                            change.newValue = this.normalize(change.newValue).search;
                            break;
                        case "hash":
                            change.newValue = this.normalize(change.newValue).hash;
                            break;
                    }
                }
                return change;
            }),
            // sync location.search with URLSearchParams()-helper
            mobx_1.reaction(() => this.location.search, search => {
                const params = this.searchParams.toString({ withPrefix: true });
                if (search !== params) {
                    this.searchParams.replace(search);
                }
            }),
            // sync from URLSearchParams()-api updates
            mobx_1.reaction(() => this.searchParams.toString({ withPrefix: true }), search => {
                if (this.location.search !== search) {
                    this.location.search = search;
                }
            }),
            // update history.js state from observable location changes
            mobx_1.reaction(() => history_1.createPath(this.location), path => {
                let currentPath = history_1.createPath(this.history.location);
                if (currentPath !== path) {
                    this.history.push(path);
                }
            }),
            // sync state updates from history.js native apis
            this.history.listen(mobx_1.action((location, action) => {
                this.action = action;
                this.location = this.normalize(location);
            })),
        ];
        return () => {
            disposers.forEach(dispose => dispose());
        };
    }
    normalize(location, { skipEmpty = false } = {}) {
        if (typeof location === "string")
            location = history_1.parsePath(location);
        if (location.search == "?")
            location.search = "";
        if (location.hash == "#")
            location.hash = "";
        if (skipEmpty) {
            location = Object.fromEntries(Object.entries(location).filter(([chunk, value]) => !!value));
        }
        return location;
    }
    merge(location, replace = false) {
        location = Object.assign(Object.assign({}, this.location), this.normalize(location));
        if (replace) {
            this.history.replace(location);
        }
        else {
            this.history.push(location);
        }
    }
    destroy() {
        var _a;
        (_a = this.unbindEvents) === null || _a === void 0 ? void 0 : _a.call(this);
        return this.history;
    }
    toString() {
        return history_1.createPath(this.location);
    }
}
__decorate([
    mobx_1.observable
], ObservableHistory.prototype, "action", void 0);
__decorate([
    mobx_1.observable
], ObservableHistory.prototype, "location", void 0);
__decorate([
    mobx_1.observable.ref
], ObservableHistory.prototype, "searchParams", void 0);
exports.ObservableHistory = ObservableHistory;
